import {Circle, G, Path, Svg} from 'react-native-svg';

const CloseIcon = () => (
  <Svg width="70" height="70" viewBox="0 0 70 70" fill="none">
    <G filter="url(#filter0_d_2159_7951)">
      <Circle cx="35" cy="31" r="15" fill="white" />
    </G>
    <Path d="M29 25L41 37" stroke="#202020" strokeWidth="1.5" />
    <Path d="M29 37L41 25" stroke="#202020" strokeWidth="1.5" />
  </Svg>
);

export default CloseIcon;
